import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Countdown from '../countdown/countdown';
import TimerRing from '../timer-ring/timerRing';
import './vsBadge.css';

export default class VsBadge extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.roundState !== nextProps.roundState) {
      return true;
    }

    return false;
  }

  renderContent() {
    if (this.props.roundState === 'countdown' || this.props.roundState === 'processing') {
      return (
        <div className='versus-block__text'>
          <Countdown 
            startTimeSeconds={this.props.timerStartSeconds} 
            timerComplete={this.props.onTimeOut} 
            enabled={this.props.roundState === 'countdown'} />
        </div>
      );
    }

    return (<div className='versus-block__text'>vs</div>);
  }

  render() {
    return (
      <div className='versus-block-wrapper'>
        <TimerRing 
          enabled={this.props.roundState === 'countdown'} 
          paused={this.props.roundState === 'processing'} />
        <div className={`versus-block versus-block--${this.props.roundState}`}>
          {this.renderContent()}
          <div className='versus-block__overlay' />
          <div className='versus-block__icon' />
        </div>
      </div>
    );
  }
}

VsBadge.propTypes = {
  roundState: PropTypes.string,
  timerStartSeconds: PropTypes.number, 
  onTimeOut: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/vs-badge/vsBadge.js